<div class="action-header mt-5 color-light font-medium">
  {{ '#UPLOAD_ARCHIVE_VOUCHER.FIND_VOUCHER.MANUAL_INPUT' | translate }}
</div>
<soft-input
  [placeholder]="'#UPLOAD_ARCHIVE_VOUCHER.FIND_VOUCHER.PLACEHOLDER'"
  [(value)]="value"
></soft-input>
<button
  class="soft-button primary w-full mt-2 mb-2 min-height-button"
  [disabled]="!value || value === '' || (loading$ | async)"
  (click)="onSubmit()"
  >
  @if (loading$ | async) {
    <i class="fa-regular fa-spinner fa-spin mr-2"></i>
  }
  <span class="pt-1">{{
    '#UPLOAD_ARCHIVE_VOUCHER.FIND_VOUCHER.SUBMIT' | translate
  }}</span>
</button>

<div class="action-header uppercase mt-4 color-light font-medium">
  {{ '#UPLOAD_ARCHIVE_VOUCHER.FIND_VOUCHER.OR' | translate }}
</div>
<div
  class="soft-card rounded border-primary flex flex-row flex-nowrap pb-4 pt-4 pr-4 pl-4 center-v mb-1"
  (click)="startScan()"
  >
  <i class="fa-regular fa-barcode-scan fa-3x mr-2 ml-1"></i>
  <div class="flex flex-col justify-center ml-3">
    <span class="text-bold">{{
      '#UPLOAD_ARCHIVE_VOUCHER.FIND_VOUCHER.SCAN_HEADER' | translate
    }}</span>
    <span class="color-light">
      {{ '#UPLOAD_ARCHIVE_VOUCHER.FIND_VOUCHER.SCAN_DESCRIPTION' | translate }}
    </span>
  </div>
</div>
